const topics = [
  { tag: '庆余年2', heat: '986万' },
  { tag: '唐朝诡事录', heat: '872万' },
  { tag: '墨雨云间', heat: '815万' },
  { tag: '狂飙全集', heat: '763万' },
  { tag: '4K超清电影', heat: '721万' },
  { tag: '韩剧推荐', heat: '689万' },
  { tag: '国产悬疑剧', heat: '645万' },
  { tag: '免费追剧', heat: '598万' },
  { tag: '古装大剧', heat: '556万' },
  { tag: '高分美剧', heat: '512万' },
];

export default function Topics() {
  return (
    <section id="topics" className="py-16 md:py-20 px-4 md:px-6 bg-background-900/50">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-center gap-3 mb-10">
          <div className="w-1 h-7 bg-secondary-500 rounded-full"></div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">热门话题</h2>
        </div>

        <div className="flex flex-wrap gap-3">
          {topics.map((item, i) => (
            <a
              key={i}
              href="#topics"
              onClick={(e) => e.preventDefault()}
              className="group inline-flex items-center gap-3 px-5 py-3 rounded-full bg-background-800/30 hover:bg-background-800/60 border border-background-700/20 hover:border-accent-500/25 transition-all cursor-pointer"
            >
              <span className={`text-sm font-semibold ${
                i < 3 ? 'text-accent-400' : 'text-foreground-300'
              } group-hover:text-accent-400 transition-colors`}>
                #{item.tag}
              </span>
              <span className="flex items-center gap-1 text-xs text-foreground-600">
                <i className="ri-fire-line text-accent-500/60"></i>
                {item.heat}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}